'use client';

import { teamSection } from '@stereoagency/sanity-schema';
import { TeamSection as UITeamSection } from '@stereoagency/ui';
import flush from 'just-flush';
import useTranslation from 'next-translate/useTranslation';
import { formatProfileName, sanityImageAsProps } from '@/utils';
import { profilesQuery } from './profilesQuery';

type Props = Omit<typeof teamSection.schema.teamSection, '_type'> & {
  profiles: (typeof profilesQuery)[1];
};

export default function TeamSection({
  title,
  subtitle,
  members,
  profiles
}: Props) {
  const { t } = useTranslation();

  if (!members?.length) {
    return null;
  }

  return (
    <UITeamSection
      title={title}
      subtitle={subtitle}
      team={flush(
        members.map((member) => {
          const profile = profiles.find(
            (entry) => entry._id === member.profile?._ref
          );

          if (!profile?.name || !profile.image?.asset._ref) {
            return null;
          }

          return {
            image: sanityImageAsProps(profile.image),
            name: formatProfileName(profile),
            role: member.role
              ? t(`departments:${member.role}`, null, { fallback: member.role })
              : undefined,
            subtitle: member.subtitle
          };
        })
      )}
    />
  );
}
